import { render, staticRenderFns } from "./ComparisonPlanSection.vue?vue&type=template&id=69afe04f&scoped=true"
import script from "./ComparisonPlanSection.vue?vue&type=script&lang=ts"
export * from "./ComparisonPlanSection.vue?vue&type=script&lang=ts"
import style0 from "./ComparisonPlanSection.vue?vue&type=style&index=0&id=69afe04f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69afe04f",
  null
  
)

export default component.exports